import enGB from "./locales/en-GB.json"

export const DEFAULT_LOCALE = "en-GB"

const localeContext = require.context("./locales", false, /\.json$/)

export const catalogs = localeContext.keys().reduce(
	(loadedCatalogs, path) => {
		const locale = path.replace("./", "").replace(".json", "")
		loadedCatalogs[locale] = localeContext(path)
		return loadedCatalogs
	},
	{ [DEFAULT_LOCALE]: enGB }
)

const LOCALE_ALIASES = {
	en: DEFAULT_LOCALE,
	"en-au": DEFAULT_LOCALE,
	"en-gb": DEFAULT_LOCALE,
	"en-us": DEFAULT_LOCALE,
}

export function normalizeLocale(locale) {
	if (!locale || typeof locale !== "string") {
		return DEFAULT_LOCALE
	}

	const trimmed = locale.trim().replace("_", "-")
	if (!trimmed) {
		return DEFAULT_LOCALE
	}

	const [language, region] = trimmed.split("-")
	const normalized = region ? `${language.toLowerCase()}-${region.toUpperCase()}` : language.toLowerCase()
	const alias = LOCALE_ALIASES[normalized.toLowerCase()]

	return alias || normalized
}

export function getMessages(locale) {
	const normalizedLocale = normalizeLocale(locale)
	return catalogs[normalizedLocale] || catalogs[DEFAULT_LOCALE]
}

export function translate(locale, key, values = {}) {
	const messages = getMessages(locale)
	const template = messages[key] || catalogs[DEFAULT_LOCALE][key] || key

	return template.replace(/\{([a-zA-Z0-9_]+)\}/g, (_, name) => {
		if (values[name] === undefined || values[name] === null) {
			return ""
		}
		return String(values[name])
	})
}
